module.exports = __webpack_public_path__ + "img/download.d802206b.png";